import React from 'react'
import {Form, FormCell, CellBody, TextArea, CellsTitle, ButtonArea, Button, Dialog} from 'react-weui'
import {storage, setToken} from "../../utils";

export default class H5Debug extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            api: '',
            token: '',
            show: false,
            buttons: [
                {
                    label: '确定',
                    onClick: () => this.setState({show: false})
                }
            ]
        }
        this.fieldChange = this.fieldChange.bind(this)
        this.onSave = this.onSave.bind(this)
    }

    fieldChange(e, field) {
        this.setState({[field]: e.target.value})
    }

    onSave() {
        let {api, token} = this.state

        if (window.location.host === 'dbg.weike.fm') {
            setToken(token)
            storage.setItem('_api', api)
            location.href = '/'
        } else {
            this.setState({show: true})
        }
    }

    componentWillMount() {
        document.title = 'h5 debug'
    }

    render() {
        return (
            <div className="h5-debug wk-page">
                <Dialog type="ios" title="提示" buttons={this.state.buttons} show={this.state.show}>
                    你的操作有误，请稍后再试
                </Dialog>
                <CellsTitle>输入api接口</CellsTitle>
                <Form>
                    <FormCell>
                        <CellBody>
                            <TextArea placeholder="example: http://dbg.weike.fm" onChange={(e) => this.fieldChange(e, 'api')}/>
                        </CellBody>
                    </FormCell>
                </Form>

                <CellsTitle>输入token</CellsTitle>
                <Form>
                    <FormCell>
                        <CellBody>
                            <TextArea placeholder="example: MTE:1g53Ra:-bAvlZGrVX46p0MoYvF0488UbHA" onChange={(e) => this.fieldChange(e, 'token')}/>
                        </CellBody>
                    </FormCell>
                </Form>

                <ButtonArea>
                    <Button onClick={() => this.onSave()}>确定</Button>
                </ButtonArea>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/activity/H5Debug.js